function extractQuestions(content, exclude) {
  if (!content || !content.length) return [];

  return content.reduce((arr, c) => {
    if (c.question && (!exclude || c.id !== exclude)) {
      arr.push(c.question);
    }
    return arr.concat(extractQuestions(c.children || (c.block && c.block.children), exclude));
  }, []);
}

module.exports = extractQuestions;
